<div class="devices-container">
    <div class="banner">
        <div class="title">
            <fa-icon [icon]="faAngleRight"></fa-icon>
            <span>{{ 'Devices.Title' | translate }}</span>
        </div>

        <div class="action-zone">
            <button color="accent" mat-button (click)="loadDatas()">
                Rafraichir
                <mat-icon>sync</mat-icon>
            </button>
            <button color="accent" mat-button routerLink="/device">
                {{ 'Devices.ButtonDeviceCreation' | translate }}
                <mat-icon>add_circle</mat-icon>
            </button>
        </div>
    </div>

    <div class="table-container">
        <form class="filters-form" [formGroup]="filtersForm">
            <div class="mat-elevation-z8">
                <table mat-table [dataSource]="dataSource" matSort>
                    <ng-container matColumnDef="address">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>{{ 'Devices.ColumnHeaderAddress' | translate }}</span>
                            <div class="small address-column">
                                <mat-form-field class="form-field" appearance="outline">
                                    <input matInput formControlName="address" (keyup)="applyFilters()" autocomplete="off" />
                                    <button
                                        mat-icon-button
                                        matSuffix
                                        class="mat-accent search-icon"
                                        matTooltip="{{ 'Devices.ResetFilterColumn' | translate }}"
                                        (click)="resetColumnFilter('address')"
                                        type="button">
                                        <mat-icon>undo</mat-icon>
                                    </button>
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let element">{{ element.address }}</td>
                    </ng-container>

                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>{{ 'Devices.ColumnHeaderName' | translate }}</span>
                            <div class="small">
                                <mat-form-field class="form-field" appearance="outline">
                                    <input matInput formControlName="name" (keyup)="applyFilters()" autocomplete="off" />
                                    <button
                                        mat-icon-button
                                        matSuffix
                                        class="mat-accent search-icon"
                                        matTooltip="{{ 'Devices.ResetFilterColumn' | translate }}"
                                        (click)="resetColumnFilter('name')">
                                        <mat-icon>undo</mat-icon>
                                    </button>
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let element">{{ element.name }}</td>
                    </ng-container>

                    <ng-container matColumnDef="state">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>{{ 'Devices.ColumnHeaderState' | translate }}</span>
                            <div class="small state-column">
                                <mat-form-field class="form-field" appearance="outline">
                                    <mat-select formControlName="state" (selectionChange)="applyFilters()" multiple>
                                        <mat-select-trigger>
                                            @if (filtersForm.get('state').value?.includes(registrationStates.registered)) {
                                            <mat-icon class="color-registered selected-color">check_circle</mat-icon>
                                            } @if (filtersForm.get('state').value?.includes(registrationStates.unregistered)) {
                                            <mat-icon class="color-unregistered selected-color">cancel</mat-icon>
                                            } @if (filtersForm.get('state').value?.includes(registrationStates.undefined)) {
                                            <mat-icon class="color-undefined selected-color">remove_circle</mat-icon>
                                            }
                                        </mat-select-trigger>
                                        @for (state of devicesStates; track state) {
                                        <mat-option [value]="state">
                                            @if (state === registrationStates.registered) {
                                            <mat-icon class="color-registered" matTooltip="{{ 'EnumRegistrationStates.' + state | translate }}">check_circle</mat-icon>
                                            } @if (state === registrationStates.unregistered) {
                                            <mat-icon class="color-unregistered" matTooltip="{{ 'EnumRegistrationStates.' + state | translate }}">cancel</mat-icon>
                                            } @if (state === registrationStates.undefined) {
                                            <mat-icon class="color-undefined" matTooltip="{{ 'EnumRegistrationStates.' + state | translate }}">remove_circle</mat-icon>
                                            }
                                        </mat-option>
                                        }
                                    </mat-select>
                                    <button
                                        mat-icon-button
                                        matSuffix
                                        class="mat-accent search-icon"
                                        matTooltip="{{ 'Devices.ResetFilterColumn' | translate }}"
                                        (click)="resetColumnFilter('state'); $event.stopPropagation()">
                                        <mat-icon>undo</mat-icon>
                                    </button>
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let element">
                            @if (element.state === registrationStates.registered) {
                            <mat-icon class="color-registered" matTooltip="{{ 'EnumRegistrationStates.' + element.state | translate }}">check_circle</mat-icon>
                            } @if (element.state === registrationStates.unregistered) {
                            <mat-icon class="color-unregistered" matTooltip="{{ 'EnumRegistrationStates.' + element.state | translate }}">cancel</mat-icon>
                            } @if (element.state === registrationStates.undefined) {
                            <mat-icon class="color-undefined" matTooltip="{{ 'EnumRegistrationStates.' + element.state | translate }}">remove_circle</mat-icon>
                            }
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="date">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>{{ 'Devices.ColumnHeaderDate' | translate }}</span>
                            <div class="small date-column">
                                <mat-form-field class="form-field" appearance="outline">
                                    <input matInput formControlName="date" (keyup)="applyFilters()" autocomplete="off" />
                                    <button
                                        mat-icon-button
                                        matSuffix
                                        class="mat-accent search-icon"
                                        matTooltip="{{ 'Devices.ResetFilterColumn' | translate }}"
                                        (click)="resetColumnFilter('date')">
                                        <mat-icon>undo</mat-icon>
                                    </button>
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let element">
                            @if (element.state === registrationStates.registered) {
                            <span matTooltip="{{ 'Devices.TooltipRegistrationDate' | translate }}">
                                {{ element.registrationTime | translateDate : 'short' }}
                            </span>
                            } @if (element.state !== registrationStates.registered) {
                            <span matTooltip="{{ 'Devices.TooltipUnregistrationDate' | translate }}">
                                {{ element.unregistrationTime | translateDate : 'short' }}
                            </span>
                            }
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="model">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>{{ 'Devices.ColumnHeaderModel' | translate }}</span>
                            <div class="small deviceModel-column">
                                <mat-form-field class="form-field" appearance="outline">
                                    <input matInput formControlName="model" (keyup)="applyFilters()" autocomplete="off" />
                                    <button
                                        mat-icon-button
                                        matSuffix
                                        class="mat-accent search-icon"
                                        matTooltip="{{ 'Devices.ResetFilterColumn' | translate }}"
                                        (click)="resetColumnFilter('model')">
                                        <mat-icon>undo</mat-icon>
                                    </button>
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let element">{{ element.displayModel }}</td>
                    </ng-container>

                    <!-- <ng-container matColumnDef="extensions">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>{{ 'Devices.ColumnHeaderextensionsDevice' | translate }}</span>
                            <div class="small">
                                <mat-form-field class="form-field" appearance="outline">
                                    <input matInput formControlName="extensions" (keyup)="applyFilters()" autocomplete="off" />
                                    <button
                                        mat-icon-button
                                        matSuffix
                                        class="mat-accent search-icon"
                                        matTooltip="{{ 'Devices.ResetFilterColumn' | translate }}"
                                        (click)="resetColumnFilter('extensions')">
                                        <mat-icon>undo</mat-icon>
                                    </button>
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <ul>
                                @for (ext of element.extensions; track ext) {
                                <li style="list-style-type: none; white-space: nowrap">
                                    <mat-icon [class]="ext.registrationState === 'registered' ? 'color-registered' : 'color-unregistered'">
                                        @if (ext.type === 'device') { tty } @if (ext.type === 'user') { person } @if (ext.type === 'group') { group } @if (ext.type === 'service') {
                                        settings } @if (ext.type === 'queue') { call_split }
                                    </mat-icon>
                                    {{ ext.name }} ({{ ext.number }})
                                </li>
                                }
                            </ul>
                        </td>
                    </ng-container> -->

                    <ng-container matColumnDef="userState">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>{{ 'Devices.ColumnHeaderUserState' | translate }}</span>
                            <div class="small userState-column">
                                <mat-form-field class="form-field" appearance="outline">
                                    <mat-select formControlName="userState" (selectionChange)="applyFilters()" multiple>
                                        <mat-select-trigger>
                                            @if (filtersForm.get('userState').value?.includes('true')) {
                                            <mat-icon class="color-registered selected-color">check_circle</mat-icon>
                                            } @if (filtersForm.get('userState').value?.includes('false')) {
                                            <mat-icon class="color-unregistered selected-color">cancel</mat-icon>
                                            }
                                        </mat-select-trigger>
                                        <mat-option [value]="'true'"><mat-icon class="color-registered">check_circle</mat-icon></mat-option>
                                        <mat-option [value]="'false'"><mat-icon class="color-unregistered">cancel</mat-icon></mat-option>
                                    </mat-select>
                                    <button
                                        mat-icon-button
                                        matSuffix
                                        class="mat-accent search-icon"
                                        matTooltip="{{ 'Devices.ResetFilterColumn' | translate }}"
                                        (click)="resetColumnFilter('userState'); $event.stopPropagation()">
                                        <mat-icon>undo</mat-icon>
                                    </button>
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let element">
                            @if (element.userState === 'true') {
                            <mat-icon class="color-registered">check_circle</mat-icon>
                            } @else {
                            <mat-icon class="color-unregistered">cancel</mat-icon>
                            }
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="actions" stickyEnd>
                        <th mat-header-cell *matHeaderCellDef>
                            <button mat-icon-button matSuffix class="header-button" matTooltip="{{ 'Devices.ResetAllFiltersColumn' | translate }}" (click)="resetAllColumnFilter()">
                                <mat-icon>undo</mat-icon>
                            </button>
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <div class="action-column">
                                @if (element.state === registrationStates.registered) {
                                <button mat-icon-button (click)="$event.stopPropagation()" [matMenuTriggerFor]="menu">
                                    <mat-icon>more_vert</mat-icon>
                                </button>
                                }
                                <mat-menu #menu="matMenu">
                                    <button mat-menu-item (click)="onRebootClick(element.address, element.name)">
                                        <mat-icon>restart_alt</mat-icon>
                                        <span>{{ 'Devices.Restart' | translate }}</span>
                                    </button>
                                    <button mat-menu-item (click)="onRegisterClick(element.address, element.name)">
                                        <mat-icon>input</mat-icon>
                                        <span>{{ 'Devices.Register' | translate }}</span>
                                    </button>
                                    <button mat-menu-item (click)="onProvisionningClick(element.address, element.name)">
                                        <mat-icon>published_with_changes</mat-icon>
                                        <span>{{ 'Devices.Provisionning' | translate }}</span>
                                    </button>
                                </mat-menu>

                                <button mat-icon-button routerLink="/device" [queryParams]="{ id: element.address }">
                                    <mat-icon>visibility</mat-icon>
                                </button>
                                <button mat-icon-button (click)="onDeleteClick(element.address, element.name)">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns; let index = index" (click)="onMouseClick($event, index)" [class.selected]="isSelected(index)"></tr>
                </table>

                <mat-paginator [pageSizeOptions]="[25, 50, 100]" class="default-paginator"></mat-paginator>
            </div>
        </form>
    </div>
</div>
